import { LocalizedText } from "@src/app/i18n/LocalizedText";
import { ReferenceType } from "@src/app/references/Reference";

export enum FilterDisplayType {
  SHOW_ALL = "SHOW_ALL",
  SHOW_MORE = "SHOW_MORE",
  POPUP = "POPUP"
}

export type FilterData = FilterProps & {
  displayLabel: string;
  displayTooltip?: string;
  currentValue: string[];
};

export interface FilterProps {
  id: number;
  entityType: string;
  name: string;
  format?: string;
  values?: string;
  exact: boolean;
  visible: boolean;
  sequence?: number;
  valueType: string;
  valueSubType?: ReferenceType;
  displayType: FilterDisplayType;
  maxDisplayed?: number;
  labels: LocalizedText[];
  tooltips: LocalizedText[];
}
